// extracted by mini-css-extract-plugin
export default {"departments":"IE-z","departmentHeading":"JE-z","departmentSection":"KE-z","departmentName":"LE-z","departmentLink":"ME-z","expandIcon":"NE-z"};